import React, { useEffect } from 'react'
import { AppProvider } from '@toolpad/core/react-router-dom';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { extendTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LayersIcon from '@mui/icons-material/Layers';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
// import PaymentIcon from '@mui/icons-material/Payment';
// import MoneyIcon from '@mui/icons-material/Money';
import ToolbarAccount from './ToolbarAccount';
import ChangePassword from '../common/ChangePassword';
import ReceiptIcon from '@mui/icons-material/Receipt';
import EmailIcon from '@mui/icons-material/Email';
import { setFavicon } from "../../helpers/faviconUtils";
const NAVIGATION = [
  {
    kind: 'header',
    title: 'Main items',
  },
  {
    segment: 'admin',
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  {
    segment: 'admin/users',
    title: 'Users',
    icon: <PeopleAltIcon />,
  },
  {
    segment: 'admin/company',
    title: 'Company',
    icon: <AccountBoxIcon />,
  },
  {
    kind: 'divider',
  },
  {
    kind: 'header',
    title: 'Masters',
  },
  {
    segment: 'admin/process',
    title: 'Process',
    icon: <AccountTreeIcon />,
  },
  {
    segment: 'admin/stage',
    title: 'Stages',
    icon: <LayersIcon />,
    children: [
      {
        segment: 'stage',
        title: 'Stages',
        icon: <LayersIcon />,
      },

      {
        segment: 'assign-stage',
        title: 'Assign to Stage',
        icon: <LayersIcon />,
      },

    ]
  },
  // {
  //   segment: 'admin/payment-terms',
  //   title: 'Payment Terms',
  //   icon: <PaymentIcon />,
  // },
  // {
  //   segment: 'admin/pricing',
  //   title: 'Pricing',
  //   icon: <MoneyIcon />,
  // },
  {
    segment: 'admin/invoices',
    title: 'Invoices',
    icon: <ReceiptIcon />,
  },
  {
    segment: 'admin/reports',
    title: 'Email',
    icon: <EmailIcon />,
    children: [
      {
        segment: 'email_configuration',
        title: 'Email Configuration',
        icon: <EmailIcon />,
      },
      {
        segment: 'email_templates',
        title: 'Email Templates',
        icon: <EmailIcon />,
      },
      {
        segment: 'email_logs',
        title: 'Email Logs',
        icon: <EmailIcon />,
      },
      {
        segment: 'email_notification',
        title: 'Email Notification',
        icon: <EmailIcon />,
      },
    ]
  },
  // {
  //   segment: 'admin/assign-process',
  //   title: 'Assign to Process',
  //   icon: <LayersIcon />,
  // },
];

const demoTheme = extendTheme({
  colorSchemes: { light: true, dark: true },
  colorSchemeSelector: 'class',
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});



const BaseLayout = (props) => {
  const {
    ChildComponent,
    is_open,
    handleChangePasswordOpen,
    change_password,
    company_details
  } = props;

  useEffect(() => {
    if (company_details?.company_logo) {
      setFavicon(company_details.company_logo);
    }
  }, [company_details?.company_logo]);

  const handleChangePassword = () => {
    handleChangePasswordOpen(!is_open);
  };
  return (
    <AppProvider
      navigation={NAVIGATION}
      theme={demoTheme}
      branding={{
        logo: (
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <img
              src={company_details?.company_logo}
              alt="logo"
              style={{ width: "14rem", height: "auto", objectFit: 'contain' }}
              onClick={() => window.location.replace('/admin')}
            />
          </Box>
        ),
        title: '',
      }}
    >
      <DashboardLayout slots={{ toolbarAccount: ToolbarAccount }}>
        <ChildComponent />
        <ChangePassword
          change_password={change_password}
          handleChangePassword={handleChangePassword}
          open={is_open}
        />
      </DashboardLayout>
    </AppProvider>
  )
}

export default BaseLayout;